import { Typography } from "@/components/atoms";
import { getErrorMessages } from "@/helpers/reduxHelpers";
import { useResendClientInviteMutation } from "@/redux/apis/client/clientApi";
import { addToast } from "@/utils";
import { useClientsContext } from "../context";
import { ClientsConfirmStep } from "./ClientsConfirmStep";

interface ClientsResendInviteProps {
  onClose: () => void;
}

/** Confirm step before re-sending a pending client's email invitation (Figma 11234-10123). */
export const ClientsResendInvite = ({ onClose }: ClientsResendInviteProps) => {
  const { selectedClient } = useClientsContext();
  const [resendClientInvite, { isLoading }] = useResendClientInviteMutation();

  const onConfirm = () => {
    if (!selectedClient) return;

    resendClientInvite(selectedClient.id)
      .unwrap()
      .then(() => {
        addToast("success", `Invitation re-sent to ${selectedClient.email}`);
        onClose();
      })
      .catch((e) => getErrorMessages(e).forEach((m) => addToast("danger", m)));
  };

  return (
    <ClientsConfirmStep title="Resend Invitation" confirmLabel="Resend Invitation" isLoading={isLoading} onConfirm={onConfirm} onClose={onClose}>
      <Typography variant="paragraph">
        Are you sure you want to resend the email invitation to <span className="text-primary">{selectedClient?.name}</span>?
      </Typography>
    </ClientsConfirmStep>
  );
};
